import { defineMessages } from 'react-intl-next';

type MessageDefinition = {
    id: string;
    defaultMessage: string;
    description: string;
};

export const messages: {
    workColumnHeader: MessageDefinition;
    statusColumnHeader: MessageDefinition;
    priorityColumnHeader: MessageDefinition;
    assigneeColumnHeader: MessageDefinition;
    labelsColumnHeader: MessageDefinition;
    spacesColumnHeader: MessageDefinition;
    keyColumnHeader: MessageDefinition;
    typeColumnHeader: MessageDefinition;
    leadColumnHeader: MessageDefinition;
    categoryColumnHeader: MessageDefinition;
    spaceUrlColumnHeader:MessageDefinition;
} = defineMessages({
    workColumnHeader: {
        id: 'search_results_lite_issue_table_header_work',
        defaultMessage: 'Work',
        description: 'Header column text for the work column header in the search results lite Jira issue table',
    },
    statusColumnHeader: {
        id: 'search_results_lite_issue_table_header_status',
        defaultMessage: 'Status',
        description: 'Header column text for the status column header in the search results lite Jira issue table',
    },
    assigneeColumnHeader: {
        id: 'search_results_lite_issue_table_header_assignee',
        defaultMessage: 'Assignee',
        description: 'Header column text for the assignee column header in the search results lite Jira issue table',
    },
    labelsColumnHeader: {
        id: 'search_results_lite_issue_table_header_labels',
        defaultMessage: 'Labels',
        description: 'Header column text for the labels column header in the search results lite Jira issue table',
    },
    priorityColumnHeader: {
        id: 'search_results_lite_issue_table_header_priority',
        defaultMessage: 'Priority',
        description: 'Header column text for the priority column header in the search results lite Jira issue table',
    },
    spacesColumnHeader: {
        id: 'search_results_lite_project_table_header_spaces',
        defaultMessage: 'Spaces',
        description: 'Header column text for the spaces column header in the search results lite Jira project table',
    },
    keyColumnHeader: {
        id: 'search_results_lite_project_table_header_key',
        defaultMessage: 'Key',
        description: 'Header column text for the key column header in the search results lite Jira project table',
    },
    typeColumnHeader: {
        id: 'search_results_lite_project_table_header_type',
        defaultMessage: 'Type',
        description: 'Header column text for the type column header in the search results lite Jira project table',
    },
    leadColumnHeader: {
        id: 'search_results_lite_project_table_header_lead',
        defaultMessage: 'Lead',
        description: 'Header column text for the lead column header in the search results lite Jira project table',
    },
    categoryColumnHeader: {
        id: 'search_results_lite_project_table_header_category',
        defaultMessage: 'Category',
        description: 'Header column text for the category column header in the search results lite Jira project table',
    },
    spaceUrlColumnHeader: {
        id: 'search_results_lite_project_table_header_spaceUrl',
        defaultMessage: 'Space URL',
        description: 'Header column text for the space URL column header in the search results lite Jira project table',
    },
});
